import { Helmet } from "react-helmet-async"
import { AutomationsList } from "../../../../../Automations"

export default function OrganizationAutomationsPage() {
	return (
		<>
			<Helmet>
				<title>Automation Definitions</title>
			</Helmet>
			<AutomationsList />
		</>
	)
}
